export default Object.freeze({
  locales: ['en', 'nl', 'fr', 'pl'],

  fallbackLocale: 'en'
});
